export const blockIconsNotificationDoDisturb = (
	<span className='material-symbols-outlined'>do_disturb</span>
);
